module.exports = __webpack_public_path__ + "static/media/charleyfuentes-banner.82d5ba77.jpeg";